import { BaseService } from "./base.service";
import { LayerPublic } from "../models/maps/layerPublic";

export class LayerService extends BaseService {
  private static instance: LayerService;

  // Method to return the singleton instance
  public static getInstance(): LayerService {
    if (!LayerService.instance) {
      LayerService.instance = new LayerService();
    }
    return LayerService.instance;
  }

  public parseWmsBaseUrl = (url: string) => {
    const [base, query] = url.split("?");
    const params = new URLSearchParams(query);
  
    return {
      base,
      params
    };
  };

  public checkGetFeatureInfoSupport = async (
    baseUrl: string,
    layerName: string
  ) => {
    const url = `${baseUrl}?service=WMS&request=GetCapabilities`;
  
    const res = await fetch(url);
    const text = await res.text();
  
    // Check of GetFeatureInfo bestaat
    const hasFeatureInfo = text.includes("GetFeatureInfo");
  
    if (!hasFeatureInfo) {
      console.log("Geen GetFeatureInfo support");
      return false;
    }
  
    // Queryable check
    const queryable = this.isLayerQueryable(text, layerName);
    if (!queryable) {
      console.log(`Layer "${layerName}" is niet queryable`);
      return false;
    }
  
    return true;
  };

  public isLayerQueryable = (
    capabilitiesXml: string,
    layerName: string
  ): boolean => {
    const parser = new DOMParser();
    const xml = parser.parseFromString(capabilitiesXml, "text/xml");
  
    const layers = Array.from(xml.getElementsByTagName("Layer"));
  
    for (const layer of layers) {
      const nameEl = layer.getElementsByTagName("Name")[0];
  
      if (!nameEl) continue;
  
      const name = nameEl.textContent;
  
      if (name === layerName) {
        const queryableAttr = layer.getAttribute("queryable");
  
        return queryableAttr === "1";
      }
    }
  
    return false;
  };

  public buildGetFeatureInfoUrl = ({
    base,
    params,
    map,
    pixel
  }: {
    base: string;
    params: URLSearchParams;
    map: any;
    pixel: [number, number];
  }) => {
    const camera = map.getCamera();
    const bounds = camera.bounds;
  
    const canvas = map.getCanvas();
    const width = canvas.width;
    const height = canvas.height;
  
    const layers = params.get("layers");
  
    const query = new URLSearchParams({
      SERVICE: "WMS",
      VERSION: "1.3.0",
      REQUEST: "GetFeatureInfo",
      LAYERS: layers || "",
      QUERY_LAYERS: layers || "",
      STYLES: "",
      CRS: "EPSG:3857",
      BBOX: bounds.join(","),
      WIDTH: width.toString(),
      HEIGHT: height.toString(),
      INFO_FORMAT: "application/json",
      FEATURE_COUNT: "10",
      I: Math.round(pixel[0]).toString(),
      J: Math.round(pixel[1]).toString()
    });
  
    return `${base}?${query.toString()}`;
  };

  // Helpers

  public buildWmsUrl = (layer: LayerPublic): string => {
    const params = [];
    params.push("bbox={bbox-epsg-3857}");
  
    return `${layer.url}?${params.join("&")}`;
  };

  public buildWfsUrl = (
    baseUrl: string, 
    layerName: string, 
    bbox: number[]
  ) => {
    const [west, south, east, north] = bbox;
  
    const params = new URLSearchParams({
      service: "WFS",
      version: "2.0.0",
      request: "GetFeature",
      typeNames: layerName,
      outputFormat: "application/json",
      srsName: "EPSG:4326",
      bbox: `${south},${west},${north},${east},EPSG:4326`
    });
  
    return `${baseUrl}?${params.toString()}`;
  };
};

// Export an instance of the LayerService class
export const layerService = LayerService.getInstance();